const progressGraphData = (response, parameter) => {
  return response?.map((o) => {
    return {
      date: o.assessmentDateString,
      value: o.assessmentData.questions.find((d) => d.title === parameter)
        ?.value,
    };
  });
};

export default progressGraphData;
